import { render } from "./Form6.vue?vue&type=template&id=726c7e5c&scoped=true"
import script from "./Form6.vue?vue&type=script&lang=js"
export * from "./Form6.vue?vue&type=script&lang=js"

import "./Form6.vue?vue&type=style&index=0&id=726c7e5c&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726c7e5c"]])

export default __exports__